"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportHistoryStatusEnum = void 0;
var ExportHistoryStatusEnum;
(function (ExportHistoryStatusEnum) {
    ExportHistoryStatusEnum["PROCESSING"] = "processing";
    ExportHistoryStatusEnum["DONE"] = "done";
    ExportHistoryStatusEnum["FAILED"] = "failed";
    ExportHistoryStatusEnum["PARTIALLY_FAILED"] = "partially_failed";
})(ExportHistoryStatusEnum || (exports.ExportHistoryStatusEnum = ExportHistoryStatusEnum = {}));
